var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMeetIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.925781,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.925781,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#ECECF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 29.6836V32.457C31.2488 32.8711 31.0838 33.2678 30.791 33.5605C30.4982 33.8533 30.1015 34.0183 29.6875 34.0195H19.5312V29.332H26.5625V25.4258L31.25 29.6836Z",
    fill: "#00AC47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 21.5195V29.6836L26.5625 25.4258V21.5195H31.25Z",
    fill: "#31A950"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5312 16.832V21.5195H14.8438L19.5312 16.832Z",
    fill: "#EA4435"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5312 21.5195H14.8438V30.1133H19.5312V21.5195Z",
    fill: "#4285F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 18.3945V21.5195H30.8594L26.5625 25.4258V21.5195H19.5312V16.832H29.6875C30.1015 16.8332 30.4982 16.9983 30.791 17.291C31.0838 17.5838 31.2488 17.9805 31.25 18.3945Z",
    fill: "#FFBA00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5312 29.332V34.0195H16.4062C15.9922 34.0183 15.5955 33.8533 15.3027 33.5605C15.01 33.2678 14.845 32.8711 14.8438 32.457V29.332H19.5312Z",
    fill: "#0066DA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1562 19.3791V31.4729C35.1563 31.624 35.1124 31.7719 35.03 31.8985C34.9476 32.0252 34.8302 32.1252 34.692 32.1864C34.5539 32.2477 34.4009 32.2675 34.2517 32.2434C34.1025 32.2194 33.9635 32.1525 33.8516 32.051L31.25 29.6838L26.5625 25.426L30.8594 21.5197L31.25 21.1682L33.8516 18.801C33.9635 18.6995 34.1025 18.6326 34.2517 18.6086C34.4009 18.5845 34.5539 18.6043 34.692 18.6655C34.8302 18.7268 34.9476 18.8268 35.03 18.9535C35.1124 19.0801 35.1563 19.228 35.1562 19.3791Z",
    fill: "#00AC47"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 21.168V29.6836L26.5625 25.4258L30.8594 21.5195L31.25 21.168Z",
    fill: "#188038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMeetIcon);
export default __webpack_public_path__ + "static/media/googleMeetIcon.8817c39fd3e5e2ef2ffb391a5885ef6a.svg";
export { ForwardRef as ReactComponent };